import {
	Mediator,
	app,
	eData,
	payload,
	context,
} from "modular-openscriptjs";
import { inform, eParse } from "../../helpers";
import { STRINGS, api } from "../../declarations";
import { routes } from "../../backendRoutes";
import { analyze } from "../../analytics";

const broker = app("broker");
const $e = app("$e");
const route = app("router");

export default class MpesaPayment extends Mediator {
	constructor() {
		super();

		let event = {
			payment: {
				method: {
					mpesa: {
						process: true,
						confirm: true,
					},
				},
			},
		};

		broker.registerEvents(event);
	}

	$$payment = {
		method: {
			mpesa: {
				process: (ed, event) => this.processPayment(ed, event),
				confirm: (ed, event) => this.confirmPayment(ed, event),
			},
		},
	};

	async processPayment(ed, event) {
		let { meta, message } = eParse(ed);

		if (!message.paymentData?.number) {
			inform(
				"Your Mpesa Number or Transaction ID is required",
				STRINGS.ERROR
			);

			return this.broadcast($e.payment.has.processingError, ed);
		}

		if (message.paymentData.number.length < 9) {
			inform(
				"Your Mpesa number / Transaction ID is invalid",
				STRINGS.ERROR
			);

			return this.broadcast($e.payment.has.processingError, ed);
		}

		let amount = message.get("amount", null);

		let res = await api.post(`${meta.get("route")}`, {
			method: message.method,
			information: message.paymentData,
			amount,
		});

		if (!res) {
			return this.broadcast($e.payment.has.processingError, ed);
		}

		inform(res.message, STRINGS.SUCCESS);

		let paymentInfo = res.data.response;
		context("payment").mpesaInfo = paymentInfo;

		meta.mpesaInfo = paymentInfo;
		meta.put("count", 1);

		this.broadcast($e.payment.stored, payload(message, meta));

		this.broadcast("payment:method:mpesa:confirm", eData(meta, message));

		route.to(paymentInfo.toUrl);
	}

	async confirmPayment(ed, event) {
		setTimeout(
			(() => {
				this.checkPayment(ed);
			}).bind(this),
			5000
		);
	}

	async checkPayment(ed) {
		const { meta, message } = eParse(ed);
		const mpesaInfo = meta.get("mpesaInfo");

		const count = meta.get("count", 1);
		meta.put("count", count + 1);

		let res = await api.get(`${routes.payments}/${mpesaInfo.paymentId}`);

		if (!res) this.broadcast($e.payment.failed, ed);

		let payment = res.data.payment;

		let status = payment.status;

		if (status === "processing" || status === "pending") {
			inform("Awaiting payment completion");

			if (count >= 24) {
				return this.broadcast($e.payment.failed, ed);
			}

			return setTimeout(
				(() => {
					this.checkPayment(payload(message, meta));
				}).bind(this),
				5000
			);
		}

		if (status === "failed" || status === "refunded") {
			return this.broadcast($e.payment.failed, ed);
		}

		analyze("payment_made", {
			amount: payment.amount,
			currency: payment.currency,
			method: payment.method,
		});

		inform(res.message, STRINGS.SUCCESS);
		return this.broadcast($e.payment.completed, ed);
	}
}
